import React from 'react';
import LazyImage from '../components/common/LazyImage';

const PlacementCard = ({ company, image, copyImage }) => {
  return (
    <div className="relative bg-white rounded-lg overflow-hidden shadow-sm">
      <LazyImage
        src={image}
        alt={company}
        placeholderImage={copyImage ?? null}
        className="w-full h-full"
      />
      <div className="bg-gradient-to-br from-red-900/10 to-transparent"></div>
    </div>
  );
};

export default PlacementCard;